import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import JournalPartnerTagForm from '../containers/JournalPartnerTagFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class JournalPartnerTagAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `JournalPartnerTagAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('journal_partner_tag_route_add')} />
          <JournalPartnerTagForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default JournalPartnerTagAddScreen;

Logger.log('silly', `JournalPartnerTagAddScreen loaded.`);